import Web3 from "web3";
import { useWeb3React } from "@web3-react/core";

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// import WhiteListPresale from "../Components/PresaleInfo/WhiteListedPresale";
import WithdrawAndSubmit from "../Components/PresaleInfo/WithdrawAndSubmit";
// import PreSaleStartsIn from "../Components/PresaleInfo/PreSaleStartsIn";
import { TbHeart } from "react-icons/tb";

import ContributeAndClaim from "../Components/PresaleInfo/ContributeAndClaim";
import IdoDetailCard from "../Components/PresaleInfo/IdoDetailCard";
import SocialLinks from "../Components/PresaleInfo/SocialLinks";
import LoadingBar from "../Components/UI/LoadingBar";

import PresaleABI from "../abis/ABI_Presale.json";
import ERC20_ABI from "../abis/ERC20.json";
import {
    getLatestCoinPrice,
    getPresaleDetails,
    likePresale,
} from "../utils/apis";
import { timeConverter } from "../utils/utils";

import {
    PRESALE_UPCOMING,
    PRESALE_INPROGRESS,
    PRESALE_FILLED,
    PRESALE_CANCELED,
    PRESALE_ENDED,
    PRESALE_ENDED_NOT_MET_SOFTCAP,
    getTokenLink,
    PRESALE_FINALISED,
} from "../utils/constants";
import TokenStatus from "../Components/UI/TokenStatus";
import TokenDistributionChart from "../Components/PresaleInfo/TokenDistributionChart";
import { useRpcURL, useValidAccount } from "../hooks";

import { ReactComponent as BinanceCoin } from "../assets/images/launchpad/binance-coin.svg";
import PresaleContributionCard from "../Components/PresaleInfo/PresaleContributionCard";

const PresaleInfoPage = () => {
    const { address } = useParams();

    const HTTP_RPC_URL = useRpcURL();
    const { active, library } = useWeb3React();
    const { account } = useValidAccount();

    const [presaleContract, setPresaleContract] = useState(null);
    const [presaleData, setPresaleData] = useState(false);
    const [preSaleinfoArray, setPreSaleinfoArray] = useState([]);
    const [tokenAddress, setTokenAddress] = useState(null);
    // const [isWhitelisted, setIsWhitelisted] = useState(false);
    // const [isWhitelist, setIsWhitelist] = useState(false);
    const [loadingData, setLoadingData] = useState(true);
    const [offChainData, setOffChainData] = useState({});

    const [presaleStatus, setPresaleStatus] = useState("");
    const [finalized, setFinalized] = useState(false);
    const [coinPrice, setCoinPrice] = useState(0);

    const [currentTime, setcurrentTime] = useState(new Date().getTime() / 1000);

    useEffect(() => {
        if (presaleStatus !== "") {
            loadData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [presaleStatus]);

    useEffect(() => {
        const timeUpdateInterval = setInterval(
            () => setcurrentTime(new Date().getTime() / 1000),
            1000
        );
        const loadDataInterval = setInterval(() => {
            loadData();
        }, 5000);
        return () => {
            clearInterval(timeUpdateInterval);
            clearInterval(loadDataInterval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [account]);

    useEffect(() => {
        if (!presaleData) return;
        if (finalized === true) setPresaleStatus(PRESALE_FINALISED);
        else if (
            presaleData.progress >=
            presaleData.hardCap - presaleData.minCon
        )
            setPresaleStatus(PRESALE_FILLED);
        else if (currentTime < presaleData.presaleStartTime)
            setPresaleStatus(PRESALE_UPCOMING);
        else if (currentTime < presaleData.presaleEndTime) {
            if (presaleData.presaleState === 0)
                setPresaleStatus(PRESALE_CANCELED);
            else {
                // setPresaleStatus(PRESALE_ENDED);
                setPresaleStatus(PRESALE_INPROGRESS);
            }
        } else {
            //time ended
            if (presaleData.progress < presaleData.softCap)
                setPresaleStatus(PRESALE_ENDED_NOT_MET_SOFTCAP);
            else if (presaleData.presaleState === 0)
                setPresaleStatus(PRESALE_CANCELED);
            else setPresaleStatus(PRESALE_ENDED);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [presaleData, currentTime]);

    useEffect(() => {
        const fetchOffchain = async () => {
            const _offChainData = await getPresaleDetails(address);
            setOffChainData(_offChainData);
        };
        if (address === "" || address === null || address === undefined) {
        } else {
            const provider = new Web3.providers.HttpProvider(HTTP_RPC_URL);
            window.web3 = new Web3(library ? library.provider : provider);
            fetchOffchain();
            loadData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [HTTP_RPC_URL]);

    const loadData = async () => {
        const web3 = window.web3;

        let _presaleContract = new web3.eth.Contract(PresaleABI, address);
        setPresaleContract(_presaleContract);

        let [
            _coinPrice,
            _tokenName,
            _tokenSymbol,
            _tokenAddress,
            _presaleState,
            _finalized,
            _hardCap,
            _tokenListingRate,
            _tokenPresaleRate,
            // _isWhitelisted,
            // _isWhitelist,
            _contribution,
            _Mincontribution,
            _Maxcontribution,
            _tokenLockTime,
            _preSaleStartTime,
            _preSaleEndTime,
            _liqudity,
            _progress,
        ] = await Promise.all([
            getLatestCoinPrice(),
            _presaleContract.methods.tokenName().call(),
            _presaleContract.methods.tokenSymbol().call(),
            _presaleContract.methods.token().call(),
            _presaleContract.methods.presaleState().call(),
            _presaleContract.methods.finalized().call(),
            _presaleContract.methods.tokenHardCap().call(),
            _presaleContract.methods.tokenListingRate().call(),
            _presaleContract.methods.tokenPresaleRate().call(),
            // _presaleContract.methods.isWhitelisted(account).call(),
            // _presaleContract.methods.isWhitelist().call(),
            _presaleContract.methods.getContribution(account).call(),
            _presaleContract.methods.tokenMinContribution().call(),
            _presaleContract.methods.tokenMaxContribution().call(),
            _presaleContract.methods.tokenLockTime().call(),
            _presaleContract.methods.tokenStartTime().call(),
            _presaleContract.methods.tokenEndTime().call(),
            _presaleContract.methods.tokenDEXLiquidity().call(),
            _presaleContract.methods.weiRaised().call(),
        ]);
        setTokenAddress(_tokenAddress);
        // setIsWhitelisted(_isWhitelisted);
        // setIsWhitelist(_isWhitelist);
        setFinalized(_finalized);
        setCoinPrice(_coinPrice);
        _presaleState = parseInt(_presaleState);

        if (_tokenAddress === undefined) return;
        let _tokenContract = new web3.eth.Contract(
            ERC20_ABI.abi,
            _tokenAddress
        );
        const _decimals = await _tokenContract.methods.decimals().call();

        const _preInfoArray = [
            {
                cap: "Minimum",
                name: "Soft Cap",
                value: _hardCap / 2,
            },
            {
                cap: "Maximum",
                name: "Hard Cap",
                value: _hardCap,
            },
            {
                cap: "Tokens",
                name: "For Sale",
                value: (_hardCap * _tokenPresaleRate) / 10 ** _decimals,
            },
            {
                cap: "Tokens",
                name: "For Liquidity",
                value: _hardCap * _tokenListingRate,
            },
            {
                cap: "Minimum",
                name: "Contribution",
                value: web3.utils.fromWei(_Mincontribution.toString(), "ether"),
            },
            {
                cap: "Maximum",
                name: "Contribution",
                value: web3.utils.fromWei(_Maxcontribution.toString(), "ether"),
            },
            {
                cap: "Liquidity",
                name: "Percentage",
                value: _liqudity + "%",
            },
            {
                cap: "Liquidity",
                name: "Unlock Date & Time",
                value: timeConverter(_tokenLockTime),
                colspan: "col-span-2",
            },
        ];

        setPresaleData({
            tokenName: _tokenName,
            presaleState: _presaleState,
            tokenSymbol: _tokenSymbol,
            presaleStartTime: _preSaleStartTime,
            presaleEndTime: _preSaleEndTime,
            hardCap: _hardCap,
            softCap: _hardCap / 2,
            minCon: web3.utils.fromWei(_Mincontribution.toString(), "ether"),
            maxCon: web3.utils.fromWei(_Maxcontribution.toString(), "ether"),
            contribution: web3.utils.fromWei(_contribution.toString(), "ether"),
            lockupTime: _tokenLockTime,
            progress: web3.utils.fromWei(_progress.toString(), "ether"),
            presaleRate: _tokenPresaleRate / 10 ** _decimals,
        });
        // console.log(_tokenSymbol)

        setPreSaleinfoArray(_preInfoArray);
        setLoadingData(false);
    };

    const likeHandler = async (presaleAddress) => {
        // console.log(presaleAddress, account);
        const _offChainData = await likePresale(presaleAddress, account);
        setOffChainData(_offChainData);
    };

    return (
        <div className="flex flex-col md:flex-row animation-fade-in main-container gap-x-8 2xl:gap-x-16 justify-between gap-y-4">
            {loadingData ? (
                <div className="w-full">
                    <LoadingBar text="Loading Information..." />
                </div>
            ) : (
                <>
                    <div className="flex flex-col w-full rounded-lg ">
                        <div className="w-full aspect-square bg-kadItemDarkBg rounded-lg border-2 border-dashed border-[#494949]">
                            <img
                                src={getTokenLink(offChainData)}
                                className="w-full aspect-square rounded-lg"
                                alt="token avatar"
                            />
                        </div>
                        <div className="flex justify-end p-2 gap-x-2">
                            <SocialLinks offChainData={offChainData} />
                        </div>
                        <p className="text-kadGrSt pb-4 size-1">
                            {offChainData.description}
                        </p>
                        <p className="opacity-70 font-light size-sm">
                            The image and metadata above are from its official
                            website or on-chain data, cached by Running Puppets.
                            It’s our best effort, and we don’t take any
                            responsibility for any incorrectness.
                        </p>

                        <TokenDistributionChart
                            offChainData={offChainData}
                            presaleAddress={address}
                            erc20Address={tokenAddress}
                            presaleContract={presaleContract}
                        />
                        {/* <WhiteListPresale
                            isWhitelisted={isWhitelisted}
                            isWhitelist={isWhitelist}
                        /> */}
                    </div>
                    <div className="flex flex-col w-full lg:px-16 gap-2 mb-8">
                        <div className="flex items-center size-sm">
                            <h3>{presaleData.tokenName}</h3>
                            <div
                                className={`rounded-full ml-auto px-2 md:px-8 py-2 cursor-pointer bg-kadItemDarkBg hover:bg-kadComponentBg ${
                                    presaleStatus === "PRESALE_INPROGRESS"
                                        ? "glowing"
                                        : ""
                                }`}
                            >
                                <TokenStatus presaleStatus={presaleStatus} />
                            </div>
                            <div
                                className="flex items-center group duration-150 cursor-pointer bg-kadItemDarkBg hover:bg-kadComponentBg rounded-full ml-2 px-2 md:px-8 py-2"
                                onClick={() => likeHandler(address)}
                            >
                                <TbHeart
                                    className={`size-2 cursor-pointer duration-150 group-hover:stroke-kadGrSt mr-0.5 ${
                                        offChainData?.likes?.includes(account)
                                            ? "stroke-kadGrSt fill-kadGrSt"
                                            : ""
                                    }`}
                                />
                                {offChainData?.likes?.length || "0"}
                            </div>
                        </div>
                        <div className="flex items-center md:p-4">
                            <div className="flex items-center gap-2">
                                <BinanceCoin className="w-6 h-6" />
                                <div className="flex flex-col">
                                    <span className="kadComponentActive size-sm">
                                        Min. Contribution
                                    </span>
                                    <span className="leading-none">
                                        {presaleData.minCon} BNB
                                    </span>
                                </div>
                            </div>
                            <div className="hidden md:block ml-auto w-[2px] h-full bg-kadComponentBorder" />
                            <div className="ml-auto md:ml-auto flex items-center gap-2">
                                <BinanceCoin className="w-6 h-6" />
                                <div className="flex flex-col">
                                    <span className="kadComponentActive size-sm">
                                        Max. Contribution
                                    </span>
                                    <span className="leading-none">
                                        {presaleData.maxCon} BNB
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col">
                            <ContributeAndClaim
                                coinPrice={coinPrice}
                                presaleData={presaleData}
                                preSaleAddress={address}
                                active={active}
                                account={account}
                                presaleContract={presaleContract}
                                presaleStatus={presaleStatus}
                                tokenAddress={tokenAddress}
                                forceUpdate={loadData}
                            />
                            <WithdrawAndSubmit
                                preSaleAddress={address}
                                active={active}
                                account={account}
                                presaleContract={presaleContract}
                                presaleData={presaleData}
                            />
                        </div>
                        <IdoDetailCard idoDetailArray={preSaleinfoArray} />
                        <PresaleContributionCard />
                    </div>
                </>
            )}
        </div>
    );
};
export default PresaleInfoPage;
